import React from 'react';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Info } from '@material-ui/icons';
import { theme } from 'theme';
import { AccordionNameEnum, PathInfoImages } from 'utils/drupalEntities';

const capitalize = (s) =>
  (s && s[0].toUpperCase() + s.toLowerCase().slice(1)) || '';

const BlockAccordionTitle = ({
  children,
  handleDelete,
  setInfoDialog,
  formKey,
  formTitle,
  langCode,
  productLangCode,
}) => {
  const handleInfo = () =>
    setInfoDialog({
      i18n: { title: capitalize(formTitle) },
      isOpen: true,
      img: PathInfoImages(langCode)?.[AccordionNameEnum.ADDITIONAL]?.[formKey],
    });
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div>{children}</div>
      <div
        style={{
          minWidth: productLangCode?.toLowerCase() !== 'en' ? 58 : 'unset',
        }}
      >
        <Info
          style={{
            height: '25px',
            color: theme.colors.primary.grey,
            cursor: 'pointer',
            marginRight: 10,
          }}
          className="prevent-accordion"
          onClick={() => handleInfo()}
        />
        {productLangCode?.toLowerCase() !== 'en' ? (
          <DeleteForeverIcon
            style={{ height: '25px', color: theme.colors.primary.grey }}
            className="prevent-accordion"
            onClick={() => {
              return handleDelete();
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default BlockAccordionTitle;
